import styled from 'styled-components'

export const Division = styled.hr`
    background-color: #ECEDF2;
    height: 1px;
    border: 0;
`
